// Generated by Melange

import * as Belt__Belt_Array from "melange.belt/belt_Array.js";
import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function RecoverForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
    
  });
  const setToast = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setEmail = match$1[1];
  const match$2 = React.useState(function () {
    return "";
  });
  const setPhone = match$2[1];
  const phone = match$2[0];
  const match$3 = React.useState(function () {
    return "email";
  });
  const match$4 = React.useState(function () {
    return [];
  });
  const setClosures = match$4[1];
  const closures = match$4[0];
  const messages = React.useMemo((function () {
    if (payload !== undefined) {
      if (typeof payload === "string") {
        return [];
      } else if (payload.NAME === "AuthFlow") {
        return payload.VAL.messages;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }), [payload]);
  const match$5 = Belt__Belt_Array.get(messages, 0);
  const emailSent = match$5 !== undefined ? match$5.id === 1060002 : false;
  const errors = React.useMemo((function () {
    if (payload !== undefined) {
      if (typeof payload === "string") {
        return [];
      } else if (payload.NAME === "AuthFlow") {
        return payload.VAL.errors;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }), [payload]);
  React.useEffect((function () {
    Curry._1(setClosures, (function (param) {
      return Belt__Belt_Array.init(errors.length, (function (param) {
        return false;
      }));
    }));
  }), [errors]);
  const initialFocusRef = React.useRef(null);
  let tmp;
  let exit = 0;
  if (payload !== undefined && typeof payload !== "string") {
    const variant = payload.NAME;
    if (variant === "AuthFlow") {
      const payload$1 = payload.VAL;
      const __x = payload$1.errors;
      tmp = JsxRuntime.jsxs(React.Fragment, {
        children: [
          Belt__Belt_Array.mapWithIndex(__x, (function (index, error) {
            const Key = "error-" + String(index);
            return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "ml-4 text-white",
                    children: error.text
                  }),
                  JsxRuntime.jsx("button", {
                    children: JsxRuntime.jsx("img", {
                      src: StaticAsset.src("/static/icons/close-circle-white.svg")
                    }),
                    className: "border-l border-white-24 ml-3 p-2",
                    onClick: (function (param) {
                      Curry._1(setClosures, (function (param) {
                        return Belt__Belt_Array.mapWithIndex(closures, (function (i, param) {
                          return i === index;
                        }));
                      }));
                    })
                  })
                ],
                className: Cn.fromList({
                  hd: "bg-alert border border-alert-16 rounded-sm flex items-center",
                  tl: {
                    hd: Cn.on("hidden", closures.length !== 0 && closures[index]),
                    tl: /* [] */ 0
                  }
                })
              }),
              className: "fixed z-10 w-screen left-0 top-32 flex justify-center"
            }, Key);
          })),
          emailSent ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.H2.make, {
                  children: "Проверьте почту"
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "mt-2 text-gray-medium",
                  children: "Мы отправили письмо со ссылкой на восстановление пароля на указанный адрес."
                }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: "mt-2 text-gray-medium",
                  children: "Не забудьте проверить папку Спам."
                })
              ],
              className: "bg-white rounded-md shadow-sm p-10"
            }) : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(Buhta_components__Text.H4.make, {
                  className: "text-center relative",
                  children: [
                    JsxRuntime.jsx("a", {
                      children: JsxRuntime.jsx("img", {
                        src: StaticAsset.src("/static/icons/arrow-back-24.svg")
                      }),
                      className: "absolute left-4",
                      href: "/login"
                    }),
                    "Восстановление пароля"
                  ]
                }),
                JsxRuntime.jsx("hr", {
                  className: "mt-3"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                    onSubmit: (function (param) {
                      
                    }),
                    initialFocusRef: initialFocusRef,
                    action: "",
                    method_: "POST",
                    children: [
                      JsxRuntime.jsx("input", {
                        name: "csrf_token",
                        type: "hidden",
                        value: payload$1.csrf_token
                      }),
                      match$3[0] === "email" ? JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Email",
                          type_: "email",
                          name: "email",
                          required: true,
                          onChange: (function (value) {
                            Curry._1(setEmail, (function (param) {
                              return value;
                            }));
                          }),
                          inputRef: initialFocusRef,
                          value: match$1[0]
                        }) : JsxRuntime.jsxs(React.Fragment, {
                          children: [
                            JsxRuntime.jsx("input", {
                              name: "phone",
                              type: "hidden",
                              value: Formating.formatPhone(phone)
                            }),
                            JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                              value: Formating.formatPhone(phone),
                              onChange: (function (value) {
                                Curry._1(setPhone, (function (param) {
                                  return value;
                                }));
                              }),
                              required: true
                            })
                          ]
                        }),
                      JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                        kind: "primary",
                        name: "method",
                        value: "link",
                        type_: "submit",
                        className: "mt-6",
                        isWide: true,
                        children: "Продолжить"
                      })
                    ]
                  }),
                  className: "p-6 sm:p-10"
                })
              ],
              className: "bg-white rounded-md shadow-sm pt-3"
            })
        ]
      });
    } else if (variant === "AuthError") {
      const error = payload.VAL;
      const match$6 = error.reason;
      let tmp$1 = match$6 === "flow_expired" ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: "Сессия восстановления истекла, начните заново.",
              className: "text-alert"
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "mt-6 text-gray-medium",
              children: JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                className: "text-links",
                children: JsxRuntime.jsx("a", {
                  children: "Начать заново",
                  className: "link",
                  href: "/recover"
                })
              })
            })
          ],
          className: "flex flex-col space-y-2"
        }) : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
            children: error.message,
            className: "text-alert"
          }),
          className: "flex flex-col space-y-2"
        });
      tmp = JsxRuntime.jsx(Buhta_cabinet__Box.make, {
        title: "Ошибка",
        className: "relative",
        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: tmp$1
        })
      });
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
      children: "couldn't parse the payload"
    });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
    toast: match[0],
    onExpired: (function (param) {
      Curry._1(setToast, (function (param) {
        
      }));
    }),
    children: tmp
  });
}

const make = RecoverForm;

export {
  make,
}
/* Buhta_cabinet__Box Not a pure module */
